
// **************** Modal ******************** //

class SignupErrorPopup extends HTMLElement {
  connectedCallback() {

    this.innerHTML = `

      <!-- BEGIN: Modal -->

      <div id="classes-sign-up-modal" class="modal fade" tabindex="-1">
      
        <div class="modal-dialog modal-dialog-centered">

          <div class="sign-up-modal-content modal-content">

            <div class="modal-header">
              <img src="assets/logos/gcs-wordmark-code-pink.png" class="modal-logo model-title" alt="Girls Code Savannah wordmark"/>
              <button type="button" id="x-close" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body">
              <p id="sign-up-modal-text" class="font-nunito text-size-h4 text-purple my-2">
                There is an error submitting your informstion.
              </p>
            </div>

          </div>

        </div>

      </div>

      <!-- END: Modal -->

    `
  }
}

customElements.define('signup-error-popup', SignupErrorPopup);

// **************************** New Classes Email Contact Form ****************************** //

  const scriptURL = 'https://script.google.com/macros/s/AKfycbwWmxNvqWz3plC9ZWuZcEPVUhlY3_O5rVA2pVtBNJbpXYaWc6u6QDOMU-aHYDG-q-n_mw/exec'

  const signupForm = document.getElementById("signup-google-sheet");

  const firstName = document.getElementById('firstName');

  const lastName = document.getElementById('lastName');

  const email = document.getElementById('email');

  const emailSubmitButton = document.querySelector('#email-submit-button');

  // Get the modal
  var signupModal = document.getElementById("classes-sign-up-modal");

  // Access the modal
  const errorModal = new bootstrap.Modal(signupModal);

  // Get the x element that closes the modal
  var xClose = document.getElementById("x-close");

  // Changing text in modal
  const modalText = document.getElementById("sign-up-modal-text");

  

  // Listen for closing of error modal & reset text to empty

  xClose.addEventListener('click', () => {
     //console.log("Trying to close modal");
     modalText.innerHTML = ``;
  });


  // Listen for button click for form submission

  signupForm.addEventListener("submit", (event) => {

    //console.log("Submit Buttom Tapped");
    
    event.preventDefault();

    emailSubmitButton.innerHTML = `Submitting...`;

    // console.log('First Name:', firstName.value);

    // console.log('Last Name:', lastName.value);

    // console.log('Email:', email.value);

    if (firstName.value.trim() == null || firstName.value.trim() == '') {

      emailSubmitButton.innerHTML = `Submit`;

      if (signupModal) {

        //console.log("Trying to show modal");

        errorModal.show();

        modalText.innerHTML = `Please enter your first name.`;
      }

    }

    else if (lastName.value.trim() == null || lastName.value.trim() == '') {

      emailSubmitButton.innerHTML = `Submit`;

      if (signupModal) {

        //console.log("Trying to show modal");

        errorModal.show();

        modalText.innerHTML = `Please enter your last name.`;
      }

    }

    else if (email.value.trim() == null || email.value.trim() == '') {

      emailSubmitButton.innerHTML = `Submit`;

      if (signupModal) {

        //console.log("Trying to show modal");

        errorModal.show();

        modalText.innerHTML = `Please enter your email.`;
      }

    }

    else if (email.value.trim() != null) {

      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email.value.trim())) {

        fetch(scriptURL, { method: 'POST', body: new FormData(signupForm)})
      
        .then(response => {

          emailSubmitButton.innerHTML = `Submit`;

          if (signupModal) {

            //console.log("Trying to show modal");

            errorModal.show();

            modalText.innerHTML = `Thank you! We will email you when we announce new camps and classes.`;

            signupForm.reset()
          }

          // When the user clicks anywhere outside of the modal, close it
          window.onclick = function(event) {
            if (event.target == signupModal) {
              modalInstance.hide(); 
            }
          }
          
        })

        .catch(error => console.error('Error!', error.message))
      }

      else { 

        emailSubmitButton.innerHTML = `Submitting...`;

        if (signupModal) {

          //console.log("Trying to show modal");

          errorModal.show();

          modalText.innerHTML = `This is not a valid email address.`;
        }
      }
    }
  })

